/**
 * 设备报警信息看板
 * 预留：POST /api/produce/kanban/device-alarm-board
 * 与 axios baseURL（/produce）组合为 /produce/api/produce/kanban/device-alarm-board
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/device-alarm-board'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

/**
 * @param {object} params 筛选：alertType, type, alertStatus, category, startTime, endTime
 * @returns {Promise<{ list: array }>}
 */
export function fetchDeviceAlarmBoard(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
